export const _driver = 'localforage-driver-session-store';
